module.exports = __webpack_public_path__ + "static/media/orc3.414737b7.png";